import(/* webpackMode: "eager", webpackExports: ["StakingProjectClient"] */ "/codebuild/output/src4071860333/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/staking/[id]/StakingProjectClient.tsx");
